// Lecture seule : un devis peut être la source de la campagne ou d'un de ses produits.
const lireToutes = async (requete) => {
  const lignes = [];
  for (let debut = 0; ; debut += 1000) {
    const { data, error } = await requete().range(debut, debut + 999);
    if (error) throw error;
    lignes.push(...(data || []));
    if (!data || data.length < 1000) return lignes;
  }
};

export const chargerUtilisationsBoutiqueClub = async (client, groupe) => {
  const [campagnes, produits] = await Promise.all([
    lireToutes(() => client.from('boutiqueclub_campagnes').select('id,devis_source_id').eq('groupe', groupe)),
    lireToutes(() => client.from('boutiqueclub_produits').select('campagne_id,source_devis_id').eq('groupe', groupe).eq('source_origine', 'CRM'))
  ]);
  const campagneIds = new Set(campagnes.map((campagne) => String(campagne.id)));
  const parDevis = new Map();
  const ajouter = (devisId, campagneId) => {
    if (!devisId || !campagneIds.has(String(campagneId))) return;
    const cle = String(devisId).toLowerCase();
    if (!parDevis.has(cle)) parDevis.set(cle, new Set());
    parDevis.get(cle).add(String(campagneId));
  };
  campagnes.forEach((campagne) => ajouter(campagne.devis_source_id, campagne.id));
  produits.forEach((produit) => ajouter(produit.source_devis_id, produit.campagne_id));
  return new Map([...parDevis].map(([devisId, ids]) => [devisId, ids.size]));
};

export const nombreCampagnesBoutiqueClub = (utilisations, devis) =>
  devis.origine === 'CRM' ? (utilisations.get(String(devis.id).toLowerCase()) || 0) : 0;

export function BadgeBoutiqueClub({ nombre }) {
  if (!nombre) return null;
  const titre = nombre > 1 ? `Utilisé dans BoutiqueClub (${nombre} campagnes)` : 'Utilisé dans BoutiqueClub';
  return <span title={titre} aria-label={titre} style={{ display: 'inline-block', marginLeft: 6, padding: '1px 5px', borderRadius: 4, background: '#e8f1ff', color: '#0753bb', fontSize: 11, fontWeight: 800, lineHeight: '16px', verticalAlign: 'middle' }}>B</span>;
}
